export default {
  theEmailIsNecessaryToSendYouTheTicketOrInvoices:
    "The email is necessary to send you the tickets or invoices.",
  enterTheAmountInKilograms: "Enter the amount in Kilograms",
  pleaseScanAValidQRCode: "Please scan a valid QR code.",
  doYouWantToReceiveYourTicketInvoiceInYour:
    "Do you want to receive your ticket / invoice in your",
  whatDoYouWantToPay: "What do you want to pay?",
  noProductsLeftToPay: "No products left to pay",
  totalSelected: "Total selected:",
  error: "Error !",
  discard: "Discard",
  thereIsNoOrderForTheTable: "There is no order for the table",
  tableOrder: "Table Order",
  invitation: "INVITATION",
  splitAccount: "split account",
  byProducts: "by products",
  cookingMeat: "COOKING MEAT",
  chooseYourDrink: "CHOOSE YOUR DRINK",
  chooseYourDishes: "Choose your dishes",
  selectTheQRCodeOfTheTable: "Select the QR code of your table",
  oopsSelectYourTable: "Oops, select your table",
  selectYourTable: "Select your table",
  wellCooked: "Well cooked",
  toThePoint: "To the point",
  underCooked: "Undercooked",
  pleaseDecreaseTheQuantityOfProducts:
    "Please decrease the quantity of products",
  divide: "Divide",
  among: "Among",
  amountToPay: "Amount to pay",
  amount: "Amount",
  allTheProducts: "All the products",
  pleaseEnterValidAmount:
    "Please enter a valid amount greater than € 0.50 or less than"
};
